// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Typography-components-Strong-Strong-module__Strong";
var _2 = "webpack-components-core-Typography-components-Strong-Strong-module__test";
export { _1 as "Strong", _2 as "test" }
